import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { Box, Card, CardContent, CardActionArea, styled, Chip, } from '@mui/material';
import Checkbox from '../../atoms/Checkbox';
import { H5, H6, Overline, Text } from '../../atoms/typography';
import ImageWithZoom from '../../molecules/ImageWithZoom';
import { toKebabCase } from '../../../utils';
const ContentNoPadding = styled(CardContent) `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  gap: 16px;
  &:last-child {
    padding-bottom: 0;
  }
`;
const StyledProperty = styled('div') `
  display: grid;
  grid-template-columns: ${props => props.showLabels ? '144px' : ''} auto;
  align-items: center;
`;
const TRANSLATE_PREFERENCES = {
    default: { label: 'yes', value: 'no' },
    parentSku: { label: 'no', value: 'no' },
    brandSku: { label: 'no', value: 'no' },
    details: { label: 'yes', value: 'yes' },
};
const IMAGE_DIMENSIONS = {
    large: { height: '480px', width: '320px' },
    medium: { height: '312px', width: '208px' },
    small: { height: '187.5px', width: '125px', minWidth: '125px' },
};
const ItemSummary = ({ alt, canZoom = true, className = '', hasActions = false, // make state later?
imageUrl, isStacked = false, itemProperties, maxWidth = '1024px', title = 'Product', titleColor, titleIcon, onClick, showLabels = true, showWhenNoPhotoAvailable = true, variant = 'large', useCase = 'confirmation', sx = {}, itemCounts, }) => {
    const cardRef = useRef(null);
    const [isMissing, setIsMissing] = useState(false);
    const itemPropertiesDisplay = itemProperties.filter(itemProperty => itemProperty.value);
    const TitleText = useCase === 'confirmation' ? H5 : H6;
    const itemCountsChip = useMemo(() => {
        const hasItemCounts = itemCounts &&
            itemCounts?.expected !== null &&
            itemCounts?.received !== null;
        return hasItemCounts ? (_jsx(Chip
        // color='primary'
        , { 
            // color='primary'
            label: _jsx("h4", { children: `Processed: ${itemCounts?.received} / Expected: ${itemCounts?.expected}` }) })) : null;
    }, [itemCounts?.expected, itemCounts?.received]);
    return (_jsxs(Box, { className: `ItemSummary ${className}`, sx: {
            display: 'flex',
            width: 'max-content',
            position: 'relative',
            flexDirection: isStacked ? 'column' : 'row',
            gap: 1.5,
            maxWidth,
            ...sx,
        }, ref: cardRef, children: [(imageUrl || showWhenNoPhotoAvailable) && _jsx(Card, { sx: {
                    ...IMAGE_DIMENSIONS[variant],
                    display: 'flex',
                    alignItems: 'center',
                }, children: _jsx(ImageWithZoom, { imageUrl: imageUrl, alt: alt, size: { image: IMAGE_DIMENSIONS[variant].height }, maxZoomWidth: 'lg', isZoomable: canZoom, clickImageToZoom: canZoom, maxWidth: IMAGE_DIMENSIONS[variant].width, showWhenNoPhotoAvailable: showWhenNoPhotoAvailable, unavailableText: variant === 'large' ? 'No photo available' : '', showFlag: false, zoomIconSize: variant }) }), _jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                }, onClick: onClick ?? undefined, children: [_jsxs(ContentNoPadding, { children: [_jsxs(TitleText, { sx: {
                                    ...titleColor ? { color: `${titleColor}` } : undefined,
                                    display: 'flex',
                                    gap: '8px',
                                    alignItems: 'center',
                                    fontWeight: 600,
                                }, children: [title, titleIcon] }), itemCountsChip, itemPropertiesDisplay.map((property) => {
                                const translationPreference = TRANSLATE_PREFERENCES[property.key] ?? TRANSLATE_PREFERENCES.default;
                                return (_jsxs(StyledProperty, { id: `${toKebabCase(property.label)}-input`, showLabels: showLabels, children: [showLabels && (_jsx(Overline, { sx: { lineHeight: 1 }, translate: translationPreference.label, children: property.label })), _jsx(Text, { translate: translationPreference.value, children: property.value })] }, property.label));
                            })] }), hasActions &&
                        _jsx(CardActionArea, { children: _jsx(Checkbox, { label: 'missing', name: 'missing-checkbox', checked: isMissing, onChange: (e) => setIsMissing(e.target.checked) }) })] })] }));
};
export default ItemSummary;
//# sourceMappingURL=index.js.map